export const EXPOSURE_COMPUTED = "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Exposure.ExposureComputed";
export const EXPOSURE_CURRENCIES_RETRIEVED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Exposure.ExposureCurrenciesRetrieved";
